<script>
    // import Flatpickr from "./Flatpickr2.svelte";
    import flatpickr from 'flatpickr';
    import ShortcutButtonsPlugin from "shortcut-buttons-flatpickr";
    import { onMount } from 'svelte';
    import { capitalizeFirst } from './format';


    export let type = "text";
    export let name = "";
    export let label = `${type} label`;
    export let placeholder = `${type} placeholder`;
    export let helper_text = "";
    export let error_text = "";
    export let show_error = false;
    export let value = "";
    export let disabled = undefined;
    export let style = "";
    export let hidden = false;
    export let readonly = false;
    export let maxlength = 100;
    export let comparePassword;
    export let image_type = "image";
    export let file_accept = undefined;
    export let show_image_previews = false;
    let avatar;
    let file_names = [];

	const onSingleFileSelected =(e)=>{
        let image = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = e => {
            avatar = e.target.result
        };
        file_names = [];
        for(let i = 0; i < e.target.files.length; i++){
            file_names.push(`${e.target.files[i].name} (${e.target.files[i].size} bytes)`);
        }
    }

    export let word_count_limit = 5000;
    $: word_count = `(${value.length} / ${word_count_limit})`;

    export let select_options = [];
    const empty_func = Function();
    export let validation_function = undefined;
    export let blur_validate = true;
    export let keyup_validate = false;
    export const constExtFuncs = {
        validateForm() {
            fieldUpdate();
            return !show_error;
        },
    }
    export let extFuncs = undefined;
    export let focus_function = undefined;
    export let blur_function = undefined;
    export let change_function = undefined;
    export let date_config_options = undefined;

    function updateDateOptions(new_opts) {
        if(new_opts !== undefined) {
            flatpickr(`#${input_id}`, date_config_options);
        }
    }

    $: {
        updateDateOptions(date_config_options);
	}

    function fieldChange(evt) {
        if(change_function !== undefined){
            change_function(evt);
        }
    }

    function fieldFocus(evt) {
        if(focus_function !== undefined){
            focus_function(evt);
        }
    }

    function fieldBlur(evt) {
        change_function ? change_function(evt) : empty_func();
        if(blur_validate){
            fieldUpdate(evt);
        }
        if(blur_function !== undefined){
            blur_function(evt);
        }
    }

    function fieldKeyup(evt) {
        if(keyup_validate){
            fieldUpdate();
        }
    }

    const text_field_types = ["text", "textarea", "number", "password", "date"];
    let fieldUpdate = (evt) => {
        if(validation_function !== undefined){
            if(text_field_types.includes(type)) {
                value = evt.target.value;
                if (validation_function()) {
                    if (label.includes('New Password')) {
                        comparePassword(value);
                    }
                }
            }
        }
    };

    const input_id = `input_id_${Math.floor(Math.random() * 100000)}`;

    onMount(() => {
        if(hidden === undefined) {
            hidden = false;
        }
        if(disabled === undefined) {
            disabled = false;
        }
        if(extFuncs === undefined) {
            extFuncs = constExtFuncs;
        }

        if(type === "date" || type === "daterange") {
            if(date_config_options === undefined){
                date_config_options = {dateFormat: "m/d/y"};
            }
            if(!("dateFormat" in date_config_options)) {
                date_config_options['dateFormat'] = "m/d/y";
            }
            if(!("disableMobile" in date_config_options)) {
                date_config_options['disableMobile'] = true;
            }

            if(type === "daterange") {
                date_config_options["mode"] = "range";
            }

            date_config_options["plugins"] = [
                ShortcutButtonsPlugin({
                    button: [
                        {
                            label: "Clear"
                        },
                        {
                            label: "Yesterday"
                        },
                        {
                            label: "Today"
                        },
                        {
                            label: "Tomorrow"
                        }
                    ],
                    label: "",
                    onClick: (index, fp) => {
                        let date;
                        switch (index) {
                        case 0:
                            fp.clear();
                            fp.close();
                            break;
                        case 1:
                            date = new Date(Date.now() - 24 * 60 * 60 * 1000);
                            fp.close();
                            break;
                        case 2:
                            date = new Date();
                            fp.close();
                            break;
                        case 3:
                            date = new Date(Date.now() + 24 * 60 * 60 * 1000);
                            fp.close();
                            break;
                        }
                        fp.setDate(date);
                    }
                })
            ]
            flatpickr(`#${input_id}`, date_config_options);
        }
    });
</script>

<div class="group {(hidden) ? "hidden" : "" }" 
    style="padding-left: 5px;padding-right: 5px;margin-left: 0px;margin-right: 0px;{label === 'Time Zone' ? "min-width: 370px;max-width: 370px;" : ""} {style}"
>
    <label class="small ifta-label {(type === "select") ? "select-label" : ""} {(type === "textarea") ? "textarea-label" : ""} {(type === "textarea" && disabled) ? "disabled" : ""}" for="{input_id}">{label} {(type === "textarea") ? word_count : ""}</label>

    {#if type === "singleimage"}
        <div class="singleimageholder ifta-field">
            <div class="imagetoolsholder" class:disabled={disabled}>
                {#if show_image_previews}
                    {#if avatar}
                        <img class="avatar" src="{avatar}" alt="d" />
                    {:else}
                        <img class="avatar" src="{(image_type === "user") ? "/img/user_icon.png" : "/img/image_icon.png"}" alt="" /> 
                    {/if}
                {:else}
                    <div class="filenameholder">
                        {#each file_names as nf}
                            <div class="filename">{nf}</div>
                        {/each}                            
                    </div>
                {/if}

                <img class="upload" src="/img/camera_icon.png" alt="" on:click={()=>{value.click();}} />
                <div class="chan" on:click={()=>{value.click();}}>Choose Image</div>
                <input
                    disabled={disabled}
                    style="display:none"
                    type="file"
                    accept={file_accept}
                    on:change={(e)=>onSingleFileSelected(e)}
                    bind:this={value}
                />
            </div>
        </div>
    {/if}

    {#if type === "toggle"}
    <div class="toggleholder" style="position: relative;">

        <input
            type="checkbox"
            id="{input_id}"
            name={name}
            style="padding-top: 25px;height: 78px;"
            class="ifta-field ifta-toggle"
            readonly={readonly}
            disabled={disabled}
            on:change={(e) => {fieldChange(e);}}
            on:focus={(e) => {fieldFocus(e);}}
            on:blur={(e) => {fieldBlur(e);}}
            on:input={(e) => {fieldBlur(e);}}
            bind:checked={value}
        />
        {#if select_options.length === 2}
        <label for="{input_id}" style="position:absolute; top: 40px; left: 60px; font-size: 16px; color: black;">{ value ? select_options[0] : select_options[1] }</label>
        {/if}
    </div>
    {/if}

    {#if type === "date" || type === "daterange"}
        <input
            type="text"
            class="ifta-field {(show_error) ? "field-error" : ""}"
            id="{input_id}"
            placeholder="{placeholder}"
            name={name}
            readonly={readonly}
            disabled={disabled}
            on:change={(e) => {fieldChange(e);}}
            on:focus={(e) => {fieldFocus(e);}}
            on:blur={(e) => {fieldBlur(e);}}
            on:input={(e) => {fieldBlur(e);}}
            bind:value={value}
        />
    {/if}


    {#if type === "select"}
        <select
            class="ifta-select {(show_error) ? "field-error" : ""}"
            id="{input_id}"
            name={name}
            readonly={readonly}
            disabled={disabled}
            on:blur={(e) => {fieldBlur(e);}}
            on:input={(e) => {fieldBlur(e);}}
            bind:value={value}
        >
            {#each select_options as no}
                {#if typeof no === 'string'}
                <option value={no}>{capitalizeFirst(no.split('---')[0])}</option>
                {:else}
                <option value={no.value}>{capitalizeFirst(no.text.split('---')[0])}</option>
                {/if}
            {/each}
        </select>
    {/if}


    {#if type === "text"}
        <input
            type="text"
            class="ifta-field {(show_error) ? "field-error" : ""}"
            id="{input_id}"
            placeholder="{placeholder}"
            name={name}
            autocomplete="new-password"
            readonly={readonly}
            disabled={disabled}
            on:focus={(e) => {fieldFocus(e);}}
            on:blur={(e) => {fieldBlur(e);}}
            on:input={(e) => {fieldBlur(e);}}
            on:keyup={() => {fieldKeyup();}}
            bind:value={value}
            on:change={(e) => change_function ? change_function(e) : empty_func()}
        />
    {/if}

    {#if type === "number"}
        <input
            type="text"
            pattern="[0-9]*"
            class="ifta-field {(show_error) ? "field-error" : ""}"
            id="{input_id}"
            placeholder="{placeholder}"
            maxlength={maxlength}
            name={name}
            readonly={readonly}
            disabled={disabled}
            on:focus={(e) => {fieldFocus(e);}}
            on:blur={(e) => {fieldBlur(e);}} on:input={(e) => {fieldBlur(e);}}
            on:keyup={() => {fieldKeyup();}}
            on:input={(e) => { change_function ? change_function(e) : () => {}}}
            bind:value={value}
        />
    {/if}

    {#if type === "password"}
        <input
            class="ifta-field {(show_error) ? "field-error" : ""}"
            id="{input_id}"
            placeholder="{placeholder}"
            name={name}
            autocomplete="new-password"
            type="password"
            readonly={readonly}
            disabled={disabled}
            bind:value={value}
            on:blur={(e) => {fieldBlur(e);}}
            on:input={(e) => {fieldBlur(e);}}
        />
    {/if}

    {#if type === "textarea"}
        <textarea
            maxlength={maxlength}
            readonly={readonly}
            disabled={disabled}
            on:focus={(e) => {fieldFocus(e);}}
            on:blur={(e) => {fieldBlur(e);}}
            on:input={(e) => {fieldBlur(e);}}
            on:keyup={() => {fieldKeyup();}}
            bind:value={value}
            id="{input_id}"
            placeholder="{placeholder}"
            class="ifta-textarea {(show_error) ? "field-error" : ""}"
            rows=3
            name={name}
        ></textarea>
    {/if}

    <div class="helper-text {(show_error) ? "error" : ""}">
        <div class="helper-text-holder">
            {(show_error) ? error_text : helper_text }
        </div>
    </div>
</div>

<style> 
    .group {
        width: 100%;
        margin-top: 25px;
        position: relative;
    }
    .group:focus-within label {
        color:#357a38 !important;
    }

    label {
        display: block;
        font-size: 12px;
        color: #999;
    }

    input::placeholder,textarea::placeholder {
        color: #dfdfdf;
    }
    input:focus::placeholder,textarea:focus::placeholder {
      color: transparent;
    }
    .helper-text {
        width: 100%;
        color: #357a38;
        font-size: 12px;
    }
    .helper-text-holder {
        height: 28px;
        width: 100%;
        padding: 5px;
    }

    .ifta-label {
        margin-bottom:-30px;
        z-index:1;
        position: relative;
        padding: 0px 0px 0px 20px;
        pointer-events:none;
    }
    .textarea-label {
        margin-bottom:-20px;
        width: calc(100% - 30px);
        margin-left: auto;
        margin-right: auto;
        box-sizing: border-box;
        background-color: white;
    }
    .textarea-label.disabled {
        background-color: rgb(218,218,218) !important;
    }
    .ifta-select {
        /* border:0; */
        -moz-appearance:none; /* Firefox */
        -webkit-appearance:none; /* Safari and Chrome */
        appearance:none;
        outline:none;
        border: solid 2px #ccc;
        border-radius:6px;
        padding:35px 20px 15px;
        margin:0 0 0px;
        width:100%;
        /* box-shadow:inset 0 0 0 1px #ccc; */
    }
    .toggleholder {
        width: 100%;
    }
    .ifta-toggle {
        cursor: pointer;
        border-radius:6px;
        padding:35px 20px 15px;
        margin:0 0 0px;
        width:100%;
        height: 76.6px;
    }
    .ifta-toggle::before {
        content: "\f0c8";
        font-family: "FontAwesome", "Font Awesome 5 Pro";
        font-weight: 900;
        font-size: 34px;
        margin-bottom: 5px;
        color: #aaa;
        background-color: white;
        padding: 0 0 2px;
        pointer-events: none;
    }
    .ifta-toggle:checked::before {
        content: "\f14a";
        font-family: "FontAwesome", "Font Awesome 5 Pro";
        font-weight: 900;
        font-size: 34px;
        margin-bottom: 5px;
        color: #357a38;
        background-color: white;
        padding: 0 0 2px;
        pointer-events: none;
    }
    .select-label:after {
        content: "\f078";
        /* font-family: "Font Awesome 5 Pro,FontAwesome"; */
        font-family: "FontAwesome", "Font Awesome 5 Pro";
        font-weight: 900;
        /* font-family: "Times New Roman", Times, serif; */
        font-size: 11px;
        color: #aaa;
        right: 10px;
        top: 20px;
        padding: 0 0 2px;
        position: absolute;
        pointer-events: none;
    }
    .ifta-textarea {
        border: solid 2px #ccc;
        border-radius:6px;
        padding:35px 20px 15px;
        width:100%;
        margin-bottom: 0px;
    }

    .ifta-field {
        /* border:0; */
        -moz-appearance:none; /* Firefox */
        -webkit-appearance:none; /* Safari and Chrome */
        appearance:none;
        border: solid 2px #ccc;
        border-radius:6px;
        padding:35px 20px 15px;
        margin:0 0 0px;
        width:100%;
        /* box-shadow:inset 0 0 0 1px #ccc; */
    }
    :global(.ifta-field input[type="checkbox"]) {
        padding-top: 10px;
    }
    :global(.ifta-field input[type="text"]) {
        padding-top: 10px;
    }
    :global(.ifta-field input[type="number"]) {
        padding-top: 10px;
    }
    :global(.ifta-field.input[type="date"]) {
        padding-top: 10px;
        
    }
    .ifta-field:focus,.ifta-textarea:focus,.ifta-select:focus {
        -webkit-appearance:none;
        outline:none;
        border: solid 2px #357a38;
    }
    .error {
        color: #d90000 !important;
    }
    :global(.ifta-field.field-error,.ifta-textarea.field-error,.ifta-select.field-error) {
        -webkit-appearance:none;
        outline:none;
        border: solid 1px #d90000 !important;
    }
    .singleimageholder {
        margin: 0px;
        width: 100%;
        box-sizing: border-box;
    }
    .imagetoolsholder {
    	display:flex;
		align-items:center;
		justify-content:center;
		flex-flow:column;
    } 
    .imagetoolsholder .upload{
		display:flex;
	    height:50px;
		width:50px;
		cursor:pointer;
	}
	.imagetoolsholder .avatar{
		display:flex;
		height:200px;
		width:200px;
	}
    .imagetoolsholder.disabled {
        opacity: 0.4;
        cursor:not-allowed;
    }
    .imagetoolsholder.disabled img {
        cursor:not-allowed;
    }
    .filenameholder {
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    :global(.hidden) {
        display: none !important;
    }
</style>